import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';

export const agentNotificationStart = () => {
  return {
    type: actionTypes.AGENT_NOTIFICATION_START,
  };
};

export const agentNotificationFail = (error) => {
  return {
    type: actionTypes.AGENT_NOTIFICATION_FAIL,
    error: error,
  };
};

export const agentNotificationSuccess = (msgs) => {
  return {
    type: actionTypes.AGENT_NOTIFICATION_SUCCESS,
    msgs: msgs,
  };
};

export const agentNotification = (agentId) => {
  return (dispatch) => {
    dispatch(agentNotificationStart());
    ctiRequest['CTI_AGENT_NOTIFICATION'].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_AGENT_NOTIFICATION'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_AGENT_NOTIFICATION'])
      .then((result) => {
        if (result.data.response.status === 'SUCCESS') {
          dispatch(agentNotificationSuccess(result.data.response.msgs));
        } else {
          dispatch(agentNotificationFail(result.data.response.reason));
          
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(agentNotificationFail(err));
      });
  };
};